import { persistor } from '../store/store'

const ACCESS_TOKEN_KEY = 'accessToken'
const ID_TOKEN_KEY = 'idToken'
const EMAIL_TOKEN_KEY = 'email'

// Save tokens to local storage
export const saveTokens = (accessToken, idToken) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    localStorage.setItem(ID_TOKEN_KEY, idToken)
}

// Get tokens from local storage
export const getTokens = () => {
    return {
        accessToken: localStorage.getItem(ACCESS_TOKEN_KEY),
        idToken: localStorage.getItem(ID_TOKEN_KEY),
    }
}

// Remove tokens from local storage
export const clearTokens = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(ID_TOKEN_KEY)
}

export const saveEmail = (email) => {
    localStorage.setItem(EMAIL_TOKEN_KEY, email)
}

export const getEmail = () => {
    return localStorage.getItem(EMAIL_TOKEN_KEY)
}

export const clearEmail = () => {
    localStorage.removeItem(EMAIL_TOKEN_KEY)
}

export const clearPersistedState = () => {
    persistor.purge().then(() => {
        console.log('Persisted state has been cleared.')
    })
}

export const clearAllPersistedStateExceptAuth = () => {
    const keysToKeep = ['persist:auth']

    Object.keys(localStorage).forEach((key) => (err, keys) => {
        if (!keysToKeep.includes(key)) {
            localStorage.removeItem(key, (err) => {
                if (err) {
                    console.error(`Error removing key ${key}`, err)
                }
            })
        }

        console.log('All slices except auth have been purged.')
    })
}
